export default __webpack_public_path__ + "fonts/SanFranciscoDisplay-Semibold.447c4b216df07564bfc7e3a7835dbfde.woff";